import { ProductTypeEnum, StoreItemEnum } from '@systemeio/digital-store-shared'
import LinkContent from 'modules/stores/store/content/link/link-content'
import OptinContent from 'modules/stores/store/content/optin/optin-content'
import Content from 'modules/stores/store/content/product/content'
import { StoreItemViewType } from 'modules/stores/store/types/store-item-interface'
import React from 'react'
import HeaderContent from '../content/header/content'

export const getItemContentByType = (item: StoreItemViewType) => {
  switch (item.type) {
    case StoreItemEnum.link:
      return <LinkContent {...item} />
    case StoreItemEnum.optin:
      return <OptinContent {...item} />
    case StoreItemEnum.header:
      return <HeaderContent {...item} />
    case StoreItemEnum.product: {
      switch (item.productType) {
        case ProductTypeEnum.download:
        case ProductTypeEnum.eCourse:
        case ProductTypeEnum.physicalProduct:
          return <Content {...item} />
      }
    }
  }
}
